<template>
  <div v-if="asset" class="completion-buttons">
    <button v-if="!moduleAssetCompleted" class="mark-complete-button btn btn-outlined" @click="handleCompletion">
      Mark as Complete
    </button>
    <button v-else class="btn btn-success" aria-describedby="mark-as-incomplete-description" @click="handleCompletion">
      <i class="fas fa-check" aria-hidden="true"></i> Completed
    </button>
    <span id="mark-as-incomplete-description" class="sr-only">Mark as incomplete</span>
    <quick-add-otj-button></quick-add-otj-button>
  </div>
</template>

<style scoped>
.completion-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.mark-complete-button {
  min-width: 170px;
  position: relative;
}

button > i {
  margin-right: 10px;
}
</style>

<script>
import QuickAddOtjButton from '@base-components/buttons/quick-add-otj-button.vue';

export default {
  components: {
    QuickAddOtjButton,
  },

  props: {
    asset: {
      type: Object,
    },
    completionPayload: {
      type: Object,
    },
    completionHandler: {
      type: Function,
    },
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  computed: {
    assetType() {
      return this.asset?.asset_type;
    },
    moduleAssetId() {
      return this.asset?.id;
    },
    moduleAssetCompleted() {
      return Boolean(this.asset?.is_complete);
    },
    completionLogPayload() {
      return { asset_type: this.assetType, module_asset_id: this.moduleAssetId };
    },
  },

  methods: {
    markComplete() {
      this.$logger.info(`Marking ${this.assetType} as complete`, this.completionLogPayload);
      this.$Loading.start();
      this.$http.put(`/api/curriculum/${this.assetType}/${this.moduleAssetId}/complete`, this.completionPayload || {})
        .then(res => {
          this.$logger.info(`Marked ${this.assetType} as complete`, this.completionLogPayload);
          this.$sidebar.updateCompletionStatus(this.assetType, this.moduleAssetId, true);
          this.$ktoast.showBadgesAchieved(res.data.badges_achieved);
        }).catch(err => {
          this.$logger.autowarn(`Error marking ${this.assetType} as complete`, this.completionLogPayload, err);
          this.$ktoast.showError(err, true);
        }).then(() => {
          this.$Loading.finish();
        });
    },
    markIncomplete() {
      this.$logger.info(`Marking ${this.assetType} as incomplete`, this.completionLogPayload);
      this.$http.put(`/api/curriculum/${this.assetType}/${this.moduleAssetId}/incomplete`)
        .then(() => {
          this.$logger.info(`Marked ${this.assetType} as incomplete`, this.completionLogPayload);
          this.$sidebar.updateCompletionStatus(this.assetType, this.moduleAssetId, false);
        }).catch(err => {
          this.$logger.autowarn(`Error marking ${this.assetType} as incomplete`, this.completionLogPayload, err);
          this.$ktoast.showError(err, true);
        });
    },
    toggleCompletion() {
      if (this.moduleAssetCompleted) {
        this.markIncomplete();
      } else {
        this.markComplete();
      }
    },
    handleCompletion() {
      if (this.completionHandler) {
        this.completionHandler();
        return;
      }
      this.toggleCompletion();
    },

  },
};
</script>
